export default "__VITE_ASSET__SCTGiPIJ__"